import React, {useState} from 'react';

import CheckBoxComponentV2 from '../../common/genericComponents/redesign/checkBoxComponentV2/checkBoxComponentV2';
import ConsentHtmlTextComponent from './consentHtmlTextComponent';
import FormComponentV2 from '../../common/genericComponents/redesign/formComponentV2/formComponentV2';

import './consentComponent.css';

const ConsentComponent = ({
  isChecked = false,
  consentTxt = '',
  title = 'Consent',
  onConsentChange = () => {},
  onConsentReadMoreClicked = () => {},
}) => {
  const primaryBackgroundColor = getComputedStyle(
    document.documentElement,
  ).getPropertyValue('--et-mentor-primary-background-color');

  const [showConsentPopUp, setShowConsentPopUp] = useState(false);
  const [showReadMoreBtn, setShowReadMoreBtn] = useState(false);

  const onReadMoreClicked = () => {
    onConsentReadMoreClicked();
    setShowConsentPopUp(true);
  };

  const onClose = () => {
    setShowConsentPopUp(false);
  };

  return (
    <div className="et-v2-consent-container">
      {showConsentPopUp && (
        <FormComponentV2
          showRightBtn={false}
          formTitle={title}
          leftBtnTxt="Close"
          onLeftBtnClicked={onClose}>
          <ConsentHtmlTextComponent consentTxt={consentTxt} />
        </FormComponentV2>
      )}
      <div className="et-v2-consent-content">
        <CheckBoxComponentV2 isChecked={isChecked} onClick={onConsentChange} />
        <ConsentHtmlTextComponent
          shouldShowReadMore
          consentTxt={consentTxt}
          setShowReadMoreBtn={setShowReadMoreBtn}
        />
        {showReadMoreBtn && (
          <div
            className="et-v2-consent-read-more-wrap"
            style={{
              background: `linear-gradient(
            to right,
            ${primaryBackgroundColor + 10} -25%,
            ${primaryBackgroundColor} 25%
          )`,
            }}
            onClick={onReadMoreClicked}>
            <div className="et-v2-consent-read-more-txt">...Read more</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsentComponent;
